type CubicBezier = readonly [number, number, number, number];

const MotionEaseSmooth = Object.freeze([0.25, 0.8, 0.25, 1]) satisfies CubicBezier;
const MotionEaseModal = Object.freeze([0.23, 1, 0.32, 1]) satisfies CubicBezier;

export const MotionEase = Object.freeze({
    Smooth: MotionEaseSmooth,
    Modal: MotionEaseModal,

    In: 'easeIn',
    Out: 'easeOut'
});

export const MotionDuration = Object.freeze({
    Fade: 0.35,
    Height: 0.35,
    Modal: 0.8,
    Opacity: 0.3,
    Press: 0.16
});

export const MotionType = Object.freeze({
    Spring: 'spring',
    Tween: 'tween'
});

export const PointerEvents = Object.freeze({
    Auto: 'auto',
    None: 'none'
});

export const Opacity = Object.freeze({
    Hidden: 0,
    Visible: 1
});
